import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from '../../environments/environment';
import { GetSupplierQueryResponse, GetSuppliersQueryResponse, CreateSupplierCommand, UpdateSupplierCommand } from '../interfaces/interfaces';

@Injectable({
  providedIn: 'root'
})
export class SuppliersService {
  private baseUrl: string;

  constructor(private http: HttpClient) {
    this.baseUrl = environment.apiSite.endsWith('/') 
      ? environment.apiSite.slice(0, -1) 
      : environment.apiSite;
  }

  // Get a single supplier by ID
  getSupplier(params: { id: number }): Observable<GetSupplierQueryResponse> {
    return this.http.get<GetSupplierQueryResponse>(`${this.baseUrl}/api/Supplier/${params.id}`);
  }

  // Get all suppliers
  getAllSuppliers(): Observable<GetSuppliersQueryResponse> {
    return this.http.get<GetSuppliersQueryResponse>(`${this.baseUrl}/api/Supplier`);
  }

  // Create a new supplier
  createSupplier(command: CreateSupplierCommand): Observable<any> {
    return this.http.post(`${this.baseUrl}/api/Supplier`, command);
  }

  // Update an existing supplier
  updateSupplier(command: UpdateSupplierCommand): Observable<void> {
    return this.http.patch<void>(`${this.baseUrl}/api/Supplier`, command);
  }
} 